import { grey } from "@mui/material/colors";

import { TASK_PRIORITY_COLORS } from "constants/staff-tasks";

/**
 * A completed/cancelled task greys its title, description, assignee and
 * due-date pill. The priority emblem follows the same rule so a finished task
 * stops signalling that it still needs attention.
 */
export const COMPLETED_PRIORITY_ICON_COLOR = grey[500];

export const getPriorityIconColor = (priority: number, isComplete = false) =>
  isComplete
    ? COMPLETED_PRIORITY_ICON_COLOR
    : TASK_PRIORITY_COLORS.getFromCode(priority);
